import { render, staticRenderFns } from "./order-component.vue?vue&type=template&id=b3570e76&"
import script from "./order-component.vue?vue&type=script&lang=js&"
export * from "./order-component.vue?vue&type=script&lang=js&"
import style0 from "./order-component.vue?vue&type=style&index=0&id=b3570e76&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports